const MINIMUM_SECONDS_LENGTH = 15;
const NORMAL_ALIGNMENT_SCORE = 0.4;
const HIGH_ALIGNMENT_SCORE = 0.6;

export { MINIMUM_SECONDS_LENGTH, NORMAL_ALIGNMENT_SCORE, HIGH_ALIGNMENT_SCORE };
